import { render } from "./SidebarLayout.vue?vue&type=template&id=5c21a8d6"
const script = {}

import exportComponent from "/codebuild/output/src804629530/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__